<script lang="ts">
    import BarLoader from "svelte-loading-spinners/BarLoader.svelte"
    import { maxInputLength } from "../../../../../../api/hooks/config-client"
    import { getCountries, getCountriesList } from "../../../../api"
    import { login } from "../../../../functionTools/login"
    import { inquiry } from "../../../../functionTools/offerAssistant"
    import { initialLocale, langField } from "../../../../i18n"
    import FormInputText from "../../../widgets/Form/FormInputText.svelte"
    import { _ } from "svelte-i18n"
    import Select from "svelte-select/Select.svelte"
    import { selectTouchFix } from "../../../../lib/actions/selectTouchFix"

    let country: { label: string; value: string } | null = $state(null)
    let countries: { label: string; value: string }[] = $state([])
    getCountries({ valid_for_inquiry: true }, "name." + initialLocale).then((res) => {
        countries = res.data.map((c: Country) => {
            const countryObj = {
                label: langField(c.name, ""),
                value: c.code,
            }
            if ($inquiry.billingAddress.countryCode === c.code) country = countryObj
            return countryObj
        })
    })
</script>

<div class="col-md-6">
    <FormInputText
        name="vorname"
        label="{$_('inquiry.firstname')} {$inquiry.customerType === 'business' ? `(${$_('inquiry.optional')})` : ''}"
        bind:value={$inquiry.billingAddress.firstname}
        type="text"
        maxlength={maxInputLength.firstname}
        required={$inquiry.customerType === "end"}
    />
</div>
<div class="col-md-6">
    <FormInputText
        name="nachname"
        label="{$_('inquiry.lastname')} {$inquiry.customerType === 'business' ? `(${$_('inquiry.optional')})` : ''}"
        bind:value={$inquiry.billingAddress.lastname}
        type="text"
        maxlength={maxInputLength.lastname}
        required={$inquiry.customerType === "end"}
    />
</div>
<div class="col-md-12">
    <FormInputText
        name="firma"
        label="{$_('inquiry.company')} {$inquiry.customerType === 'end' ? `(${$_('inquiry.optional')})` : ''}"
        bind:value={$inquiry.billingAddress.company}
        type="text"
        maxlength={maxInputLength.company}
        required={$inquiry.customerType === "business"}
    />
</div>
<div class="col-md-6">
    <FormInputText
        name="strasse"
        label={$_("inquiry.street")}
        bind:value={$inquiry.billingAddress.street}
        type="text"
        required
        maxlength={maxInputLength.street}
    />
</div>
<div class="col-md-6">
    <FormInputText
        name="hausnummer"
        label={$_("inquiry.house-number")}
        bind:value={$inquiry.billingAddress.houseNumber}
        type="text"
        required
        maxlength={maxInputLength.houseNumber}
    />
</div>
<div class="col-md-12" use:selectTouchFix>
    <Select
        items={countries}
        inputAttributes={{ autocomplete: "off" }}
        placeholder="Land"
        showChevron={true}
        required={true}
        bind:value={country}
        on:change={(e) => {
            if (e.detail.value) {
                $inquiry.billingAddress.countryCode = e.detail.value
            }
        }}
    />
</div>
<div class="col-md-6">
    <FormInputText
        name="plz"
        label={$_("inquiry.postcode")}
        bind:value={$inquiry.billingAddress.postcode}
        type="text"
        required
        pattern={$inquiry.billingAddress.countryCode == "DE" ? "^\\d{5}$" : undefined}
        maxlength={maxInputLength.postcode}
    />
</div>
<div class="col-md-6">
    <FormInputText
        name="ort"
        label={$_("inquiry.city")}
        bind:value={$inquiry.billingAddress.city}
        type="text"
        required
        maxlength={maxInputLength.city}
    />
</div>
